import cn from 'classnames';

interface LabelProps {
    label: string;
    className?: string;
    description?: string;
    required?: boolean;
    alignStart?: boolean;
}
const defaultLabelWidth = 'sm:min-w-60';

const Label = (props: LabelProps) => {
    const { description = '', label = '', className, required = false, alignStart = false } = props;

    return (
        <div
            className={cn('hidden xsm:flex flex-row items-center flex-none', {
                ['py-1.5']: alignStart
            })}>
            <div
                className={cn('flex flex-col w-28', {
                    [`${className}`]: className,
                    [defaultLabelWidth]: !className
                })}>
                <label className="flex justify-between relative w-full">
                    <div
                        className={cn('', {
                            'pl-3': required
                        })}>
                        {required && <sup className="absolute -top-1 left-0 text-lg mr-1.5 text-secondary-300">*</sup>}
                        {label}
                    </div>
                </label>
                {description ? (
                    <div className="text-xs text-brand-neutral-500 w-full white max-w-60">{description}</div>
                ) : null}
            </div>
            <div>
                <span className="space-x-1.5">
                    <span>:</span>
                </span>
            </div>
        </div>
    );
};

export default Label;
